import { useTranslation } from "react-i18next";
import { Navigate, useParams } from "react-router";
import { LoadingView } from "@/components/LoadingView/LoadingView";
import { useCcAccess } from "@/hooks/useCcAccess/useCcAccess";
import { useEvaluation } from "@/hooks/useEvaluation/useEvaluation";
import { EvaluationEmptyState } from "../EvaluationEmptyState/EvaluationEmptyState";
import { EvaluationScorecards } from "../EvaluationScorecards/EvaluationScorecards";

export function EvaluationEmptyView() {
  const { t } = useTranslation();
  const { canRead } = useCcAccess();

  const { callId } = useParams();

  const { evaluation, loading } = useEvaluation(callId);

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <LoadingView className="mt-0" />
      </div>
    );
  }

  if (evaluation && !loading) {
    return <Navigate to="result" />;
  }

  // This condition is for the Agent view
  if (!canRead) {
    return (
      <EvaluationEmptyState title={t("evaluation.empty_view.title_agent")} />
    );
  }

  return (
    <div
      className="flex h-full items-center justify-center"
      data-test="evaluation-empty-section"
    >
      <EvaluationScorecards />
    </div>
  );
}
